import React, { useEffect, useMemo, useState } from 'react';
import Slider from 'react-slick';
import PageService from '@apiService/PageService.js';

const PremierMenu = () => {
  const [premierData, setPremierData] = useState([]);

  const getData = () => {
    const payload = {
      mpm_name: 'premiere',
      mpm_lang_id: 1,
    };

    PageService.GetPageData(payload)
      .then((r) => {
        if (r?.data?.status) {
          setPremierData(r.data.Records || []);
        }
      })
      .catch((err) => {
        console.error('Premier API error =>', err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  /**
   * Banner slider data
   */
  const bannerData = useMemo(() => {
    const banners = premierData?.[0]?.mpm_banner;
    return banners ? banners.split(',') : [];
  }, [premierData]);

  /**
   * Vertical content list
   */
  const contentList = useMemo(() => {
    return premierData.filter((x) => x.mpm_d_is_active === 'Y' && x.mpm_d_images);
  }, [premierData]);
  const isSingleBanner = bannerData.length === 1;
  /**
   * Slick settings
   */
  const bannerSliderSettings = {
    dots: !isSingleBanner,
    arrows: false,
    infinite: !isSingleBanner,
    autoplay: !isSingleBanner,
    autoplaySpeed: 5000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: !isSingleBanner,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: !isSingleBanner,
        },
      },
    ],
  };

  return (
    <div className="premier-menu-wrapper">
      {/* ================= BANNER SLIDER ================= */}
      {bannerData.length > 0 && (
        <div className="premier-banner-slider mb-5">
          <Slider {...bannerSliderSettings}>
            {bannerData.map((banner, index) => (
              <div key={index} className="banner-slide">
                <img
                  src={banner}
                  alt={`Premier Banner ${index + 1}`}
                  className="img-fluid w-100"
                />
              </div>
            ))}
          </Slider>
        </div>
      )}

      {/* ================= VERTICAL CONTENT ================= */}
      <div className="premier-content-list">
        {contentList.map((item) => (
          <div key={item.mpm_d_id} className="premier-content-item">
            <div className="premier-text">
              {item.mpm_d_header_name && (
                <h3 className="premier-header">{item.mpm_d_header_name}</h3>
              )}

              {item.mpm_d_description && (
                <p className="premier-description">{item.mpm_d_description}</p>
              )}
            </div>

            <div className="premier-image">
              <img src={item.mpm_d_images} alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PremierMenu;
